// Formik errors are alphabetically sorted by default
// We need to sort field elements by their position on the page, so it's focused in the correct order
export function sortElementsByScreenPosition(a: HTMLElement, b: HTMLElement) {
    const aRect = a.getBoundingClientRect()
    const bRect = b.getBoundingClientRect()

    if (aRect.top === bRect.top) {
        return aRect.left - bRect.left
    }

    return aRect.top - bRect.top
}
